import { render } from "./designerApply.vue?vue&type=template&id=2f970fdf&scoped=true"
import script from "./designerApply.vue?vue&type=script&lang=js"
export * from "./designerApply.vue?vue&type=script&lang=js"

import "./designerApply.vue?vue&type=style&index=0&id=2f970fdf&lang=scss&scoped=true"
import "./designerApply.vue?vue&type=style&index=1&id=2f970fdf&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f970fdf"]])

export default __exports__